<template>
  <div id="lock-win" v-if="smallDialogShow">
    <h4>
      已添加的测点
      <i class="iconfont icon-fullscreen icon mr-20px" @click="toggleSmallDialog('magnify')"></i>
      <i class="icon el-icon-circle-close-outline" @click.stop="closeLockWin"></i>
    </h4>
    <ul class="tagId-list">
      <li v-for="(item, index) in tagIdTbData" :key="index">
        {{ item }}
        <i class="icon el-icon-circle-close-outline" @click.stop="deleteTagId(item)"></i>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
export default {
  props: {
    tagIdTbData: {
      type: Array,
      default: () => {
        return []
      },
    },
    smallDialogShow: Boolean,
  },
  data() {
    return {
      isShowPointDialog: false, // 是否显示添加测点弹窗
      condition: null,
    }
  },
  methods: {
    /* 还原到正常弹窗 */
    toggleSmallDialog(type) {
      this.$emit('on-toggle', type)
    },
    /* 关闭 */
    async closeLockWin() {
      this.$emit('on-close')
    },
    /* 删除 */
    async deleteTagId(item) {
      this.$emit('on-delete', item)
    },
  },
}
</script>
<style scoped lang="scss">
#lock-win {
  position: fixed;
  z-index: 3000;
  height: 200px;
  width: 300px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.5);
  text-align: left;
  text-indent: 10px;
  border: 1px solid #d9d9d9;
  left: 170px;
  bottom: 15px;
  h4 {
    font-size: 13px;
    color: #000;
    height: 38px;
    line-height: 38px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 0;
    background: rgba(245, 245, 245, 0.9);
    letter-spacing: 2px;
    font-weight: bold;
    cursor: pointer;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 5px;
      top: 8px;
      font-size: 14px;
      &:hover {
        color: #1890ff;
      }
    }
  }
  .tagId-list {
    height: 162px;
    overflow-y: auto;
    margin: 0;
    background: #fff;
    li {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      // background: rgba(0, 0, 0, 0.5);
      color: #000;
      border-bottom: 1px solid #d9d9d9;
      margin: 0;
      position: relative;
      cursor: pointer;
      .icon {
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 4px;
        font-size: 14px;
        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
// 媒体查询
@media screen and (max-width: 1366px) {
  #lock-win {
    height: 174px;
    width: 230px;
    h4 {
      height: 33px;
      line-height: 33px;
      .icon {
        top: 5px;
      }
    }
    .tagId-list {
      li {
        height: 28px;
        line-height: 28px;
        .icon {
          top: 2px;
        }
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  #lock-win {
    height: 174px;
    width: 250px;
    h4 {
      height: 33px;
      line-height: 33px;
      .icon {
        top: 5px;
      }
    }
    .tagId-list {
      li {
        height: 28px;
        line-height: 28px;
        .icon {
          top: 2px;
        }
      }
    }
  }
}
</style>
